import React from 'react';
import Scrollbar from 'react-scrollbars-custom';
import styled from 'styled-components';
import { colors } from '../../../utils/utils';

const Wrapper = styled.div`
    padding: 0 2px 0 10px;
`;

export function ScrollableContainer({ children }: { children?: React.ReactNode }) {
    return (
        <Scrollbar
            removeTracksWhenNotUsed
            trackYProps={{
                style: {
                    width: '4px',
                    right: '2px',
                    background: 'none'
                }
            }}
            thumbYProps={{
                style: {
                    background: colors.gray.iron
                }
            }}
            scrollerProps={{
                renderer: (props: { elementRef: (el: HTMLDivElement | null) => void } & React.HTMLAttributes<HTMLDivElement>) => {
                    const { elementRef, ...restProps } = props;
                    return <div {...restProps} ref={elementRef} data-scroller="true" />;
                }
            }}>
            <Wrapper>{children}</Wrapper>
        </Scrollbar>
    );
}
